import { useEffect, useState } from "react";

import { IDateRange, isOrderedRange, isWithinMaxRange } from "@prostocheck/shared";

/**
 * The range a query is actually built from: the last one whose end is not
 * before its start and, when `maxDays` is given, spans no more than that.
 * Halfway through fixing a period — the moment the new start is typed but the
 * end is still the old one, or the span now runs too long — the screen keeps
 * the rows it has instead of asking ДПС for an invalid period and blanking
 * the table. `maxDays` is the caller's to set: this hook has no opinion on
 * what a period is for.
 */
export const useAppliedDateRange = (
  { from, to }: IDateRange,
  maxDays?: number,
): IDateRange => {
  const [applied, setApplied] = useState<IDateRange>({ from, to });

  useEffect(() => {
    const isValid =
      isOrderedRange({ from, to }) &&
      (maxDays === undefined || isWithinMaxRange({ from, to }, maxDays));

    if (isValid) setApplied({ from, to });
  }, [from, to, maxDays]);

  return applied;
};
